/**
 * **What a card may write to, and the rule that it writes to nothing it was not named.**
 *
 * The ids a card writes against — the plan assignment, the goal, the invitation — are additive
 * payload fields (24 September 2026). An item from an older backend carries none of them, and the
 * card then keeps its read and draws no write, rather than writing to a guessed record: the plan's
 * "active assignment" is a fine thing to READ for a cover, and the wrong thing to close. One place
 * for that rule, because three blocks (`PlanBlock`, `GoalBlock`, `InvitationBlock`) each drew it.
 *
 * Pure.
 */

import type { AttentionItem } from './attentionItems';

export interface TaskPlanTarget {
  readonly assignmentId: number;
  readonly clientId: number | null;
}

export interface TaskGoalTarget {
  readonly clientId: number;
  readonly goalId: number;
}

export interface TaskWriteTargets {
  /** „Dodaj tydzień", „Zakończ plan" — `null` without `planAssignmentId`. */
  readonly plan: TaskPlanTarget | null;
  /** „Przedłuż", „Ukończ cel" — `null` without `goalId`, or without the client whose goal it is. */
  readonly goal: TaskGoalTarget | null;
  /** „Wyślij zaproszenie ponownie" — `null` without `invitationId`. */
  readonly invitationId: number | null;
}

export function taskWriteTargets(item: AttentionItem): TaskWriteTargets {
  const { planAssignmentId, goalId, invitationId } = item.triage;
  const clientId = item.subjectCustomerId;
  return {
    plan: planAssignmentId === null ? null : { assignmentId: planAssignmentId, clientId },
    goal: goalId === null || clientId === null ? null : { clientId, goalId },
    invitationId,
  };
}
